module.exports = __webpack_public_path__ + "media/img/pages/profile/aldi ger 3-a4ea116243989a33615cd73b1ee9ebf9.jpg";